var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"ml-1",attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarCancelarContrato()}}},[_c('span',[_c('i',{staticClass:"fa fa-times-circle mr-2"}),_vm._v(" Cancelar Contrato ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }